import { useMutation } from "react-apollo"
import gql from "graphql-tag"
import { ROOT_QUERY_USER_FRAGMENT } from "graphql/queries/user"
import { UpdateUserProductsMutation, UpdateUserProductsMutationVariables } from "typings/types"

const UPDATE_USER_PRODUCTS_MUTATION = gql`
  mutation UpdateUserProducts($params: UpdateUserProductsParams!) {
    updateUserProducts(params: $params) {
      ...RootQueryUserFragment
    }
  }
  ${ROOT_QUERY_USER_FRAGMENT}
`

export const useUpdateUserProducts = () =>
  useMutation<UpdateUserProductsMutation, UpdateUserProductsMutationVariables>(UPDATE_USER_PRODUCTS_MUTATION)
